import { useState } from 'react';

interface UseFormSelectOptions {
    initialValue?: string;
    onFieldInteracted?: () => void;
    validationFunc?: (value: string) => boolean;
}

interface UseFormSelectReturn {
    value: string;
    setValue: (value: string) => void;
    valid: boolean;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const useFormSelect = (options: UseFormSelectOptions): UseFormSelectReturn => {
    const { initialValue = '', onFieldInteracted, validationFunc } = options;

    const [value, setValue] = useState(initialValue);
    const [valid, setValid] = useState(() => (validationFunc ? validationFunc(initialValue) : true));

    const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = event.target.value;

        setValue(newValue);
        setValid(validationFunc ? validationFunc(newValue) : true);

        if (onFieldInteracted) {
            onFieldInteracted();
        }
    };

    return {
        value,
        setValue,
        valid,
        onChange,
    };
};
